/* unplugin-vue-components disabled */import { render } from "./order-summary.vue?vue&type=template&id=1d6f5f8d"
import script from "./order-summary.vue?vue&type=script&lang=js"
export * from "./order-summary.vue?vue&type=script&lang=js"

import "./order-summary.vue?vue&type=style&index=0&id=1d6f5f8d&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__